import { handlePlayerNotifications } from '@store/epics/socket/handlePlayerNotifications';
import { handleTableOccupancy } from '@store/epics/socket/handleTableOccupancy';
import { EMPTY, of } from 'rxjs';

import {
  INITIAL_DATA,
  PLAYERS_NUMBER,
  INITIALIZE_TABLE,
  CANCEL_TABLE,
  UPDATED_LOBBY_DATA,
  UPDATE_FREE_SEATS,
  UPDATED_TABLE_HISTORY,
  SHUFFLE,
  PLAYER_LIMITS_NOTIFICATION,
} from '@ezugi/constants';

import { tables } from '../../tables';
import handleCurrentBalance from './handleCurrentBalance';
import handleDealerImage from './handleDealerImage';
import { handleInitialData } from './handleInitialData';
import { handlePlayersNumber } from './handlePlayersNumber';
import handleTableHistory from './handleTableHistory';

const CURRENT_BALANCE = 'CurrentBalance';
const UPDATE_BLALANCE = 'UPDATE_BLALANCE';
const UPDATE_BALANCE = 'UPDATE_BALANCE';
const ROUND_START = 'ROUND_START';
const CHANGE_DEALER = 'CHANGE_DEALER';
const UPDATE_DEALER_IMAGE = 'UpdateDealerImage';
const TABLE_OCCUPANCY = 'TABLE_OCCUPANCY';

export const handleSocketMessage = (socketMessage, state) => {
  const {
    MessageType,
    subMessageType,
    TableId,
    tableId,
    balance: _balance,
    data,
    ...rest
  } = socketMessage;

  const id = tableId || TableId;

  switch (MessageType) {
  // Update `playersCount` for each table
  case INITIAL_DATA: {
    return handleInitialData(socketMessage, state);
  }
  // Update `balance`
  case CURRENT_BALANCE: {
    return handleCurrentBalance(socketMessage);
  }
  // Update `playersCount` for one table
  case PLAYERS_NUMBER: {
    return handlePlayersNumber(socketMessage, state);
  }

  case PLAYER_LIMITS_NOTIFICATION: {
    return of(...handlePlayerNotifications(data));
  }
  case UPDATED_LOBBY_DATA: {
    switch (subMessageType) {
    case INITIALIZE_TABLE: {
      return of(
        tables.updateTable([
          {
            tableId: id,
            active: true,
          },
        ])
      );
    }
    case UPDATE_BLALANCE: // TODO: remove this once the typo is fixed on the GameEngine
    case UPDATE_BALANCE: {
      return handleCurrentBalance(socketMessage);
    }
    case CANCEL_TABLE: {
      return of(
        tables.updateTable([
          {
            tableId: id,
            active: false,
            history: [],
          },
        ])
      );
    }
    case UPDATED_TABLE_HISTORY:
    case UPDATE_FREE_SEATS: {
      return handleTableHistory(socketMessage, state);
    }
    case ROUND_START: {
      return of(
        tables.updateTable([
          {
            tableId: id,
            round_start_time: {
              time_left: rest.TimerTimeLeft ? rest.TimerTimeLeft : 0,
              timestamp: Date.now(),
            },
          },
        ])
      );
    }
    case CHANGE_DEALER: {
      return of(
        tables.updateTable([
          {
            tableId: id,
            dealer_name: rest.DealerName,
          },
        ])
      );
    }
    case UPDATE_DEALER_IMAGE: {
      return handleDealerImage(socketMessage, state);
    }
    case SHUFFLE: {
      return of(
        tables.updateTable([
          {
            tableId: id,
            history: [],
          },
        ])
      );
    }
    case TABLE_OCCUPANCY: {
      return handleTableOccupancy(socketMessage, state);
    }
    default: {
      return EMPTY;
    }
    }
  }
  default: {
    return EMPTY;
  }
  }
};
